import SubTopicList from "./components/List";

const SubtopicPage = () => {
    return (
        <SubTopicList />
    )
}

export default SubtopicPage;